import * as React from "react";
import { Project } from "src/redux/projects";
import { Link } from "react-router-dom";
import { WithNamespaces, withNamespaces } from "react-i18next";
import { HeaderPage } from "./HeaderPage";
import {Badge} from "reactstrap";

interface Props {
  projects: Project[];
}
type PropsWithNamespaces = Props & WithNamespaces;
const ProjectsPage = (props: PropsWithNamespaces) => (
  <div className="projects">
    <div className="mb-4">
      <HeaderPage title={props.t(`projects.title`)} />
    </div>

    <div className="container-fluid">
      <div className="row">
        {props.projects.map((p) => (
          <div className="col-12 col-lg-4 pr-4 pb-5" key={p.id}>
            <Link
              className="text-decoration-none"
              to={{
                pathname: `/projects/${p.id}`,
              }}
            >
              <div
                className={`card card-project ${
                  p.prestationsAction.length > 0 ? "current" : ""
                }`}
              >
                <div className="card-header">
                  <div className="card-header-img">
                    {!p.image && (
                      <img className="default" src="assets/presta-defaut.jpg" />
                    )}
                    {p.image && <img src={p.image} />}
                  </div>
                </div>
                <div className="card-body">
                  <div className="flex-1">
                    <div>
                      <p className="mb-2 title" style={{textAlign:'center'}}>
                          <strong>{p.refArka} : {p.name}</strong><br/>
                          {p.city}
                      </p>
                    </div>
                      <div >
                          { p.prestationsAction.length &&
                              <Badge>
                                  {p.prestationsAction.length}
                              </Badge>}
                              {props.t(`projects.prestations.currentLabel`)}

                      </div>
                      <div className="d-flex align-items-center">
                        <span className="mr-2 badge badge-primary">
                          {p.prestationCount}
                        </span>
                        {props.t(`projects.prestations.label`)}
                      </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  </div>
);
export default withNamespaces()(ProjectsPage);



// WEBPACK FOOTER //
// ./src/components/Projects.tsx